import { useTexts } from '../../useTexts'

import { form } from '../../../formState'

import { useUpdateTagsWarning } from './hooks/useUpdateTagsWarning'
import { useAddTagOptions } from './hooks/useAddTagOptions'

export function Tags() {
  const texts = useTexts()

  const tagsInValue = form.useFormField('tagsIn').field.value
  const tagsOutValue = form.useFormField('tagsOut').field.value

  const tagsInOptions = useAddTagOptions(tagsInValue, tagsOutValue)
  const tagsOutOptions = useAddTagOptions(tagsOutValue, tagsInValue)

  // Update the warning state of tags when there's a collision between tagsIn and tagsOut.
  useUpdateTagsWarning()

  //Tags in validation
  form.useAddFieldValidation('tagsIn', field => {
    const tagsIn = field.value
    if (!tagsIn.tags) return

    const errorTagsIn = Object.values(tagsIn.tags).some(t => t.status === 'exact' && t.warning)
    if (errorTagsIn) {
      return texts.overlappingTags
    }
  })

  //Tags out validation
  form.useAddFieldValidation('tagsOut', field => {
    const tagsOut = field.value
    if (!tagsOut.tags) return

    const errorTagsOut = Object.values(tagsOut.tags).some(t => t.status === 'exact' && t.warning)
    if (errorTagsOut) {
      return texts.overlappingTags
    }
  })

  return (
    <form.Fieldset>
      <form.BulkTagsField
        label={texts.tagsIn}
        name="tagsIn"
        options={tagsInOptions}
        testId="tagsIn"
        bulkTagsProps={{
          bannedTagCategory: 'tagsOut',
          totalSelectedItems: tagsInValue.affectedOrdersCount,
        }}
      />

      <form.BulkTagsField
        label={texts.tagsOut}
        name="tagsOut"
        options={tagsOutOptions}
        testId="tagsOut"
        bulkTagsProps={{
          bannedTagCategory: 'tagsIn',
          totalSelectedItems: tagsOutValue.affectedOrdersCount,
        }}
      />
    </form.Fieldset>
  )
}
